import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface MaskedInputProps {
  mask: string;
  placeholder?: string;
  registration: UseFormRegisterReturn;
  error?: string;
  label: string;
}

const MaskedInput: React.FC<MaskedInputProps> = ({
  mask,
  placeholder,
  registration,
  error,
  label,
}) => {
  const applyMask = (value: string, mask: string) => {
    let maskedValue = "";
    let valueIndex = 0;

    for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
      if (mask[i] === "9") {
        if (/\d/.test(value[valueIndex])) {
          maskedValue += value[valueIndex];
          valueIndex++;
        } else {
          break;
        }
      } else {
        maskedValue += mask[i];
      }
    }

    return maskedValue;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    const maskedValue = applyMask(rawValue, mask);

    e.target.value = maskedValue;
    registration.onChange(e);
  };

  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-neutral-700">
        {label}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        {...registration}
        onChange={handleChange}
        className={`w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary ${
          error ? "border-error" : "border-neutral-300"
        }`}
      />
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
    </div>
  );
};

export default MaskedInput;
